import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconAiPlay = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...omit(props, ["className"])}
    className="yfm-icon yfm-icon-ai-play"
  >
    <path
      d="M6.0001 0.402344C3.0301 0.402344 0.600098 2.83234 0.600098 5.80234C0.600098 8.77234 3.0301 11.2023 6.0001 11.2023C8.9701 11.2023 11.4001 8.77234 11.4001 5.80234C11.4001 2.83234 8.9701 0.402344 6.0001 0.402344ZM6.0001 10.7525C3.27742 10.7525 1.04992 8.52502 1.04992 5.80234C1.04992 3.07966 3.27742 0.852164 6.0001 0.852164C8.72278 0.852164 10.9503 3.07966 10.9503 5.80234C10.9503 8.52502 8.72278 10.7525 6.0001 10.7525Z"
      fill="white"
    />
    <path
      d="M7.68782 5.06013L5.888 3.86781C5.2805 3.46281 4.76318 3.73281 4.76318 4.47531V7.17531C4.76318 7.91781 5.25836 8.18781 5.888 7.78281L7.68782 6.59049C8.29532 6.14067 8.29532 5.46567 7.68782 5.06067V5.06013Z"
      fill="white"
    />
  </svg>
));

IconAiPlay.displayName = "IconAiPlay";

export default IconAiPlay;
